export default __webpack_public_path__ + "static/media/body-female-larger.05560f83.png";